import React, { useEffect, useRef } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { StaffTopNav } from "./StaffTopNav";
import { StaffBottomNav } from "./StaffBottomNav";

/**
 * Responsive shell for /staff/* routes.
 *
 * Espresso (dark) background — staff portal is utilitarian, not editorial.
 * Same nav pattern as CustomerLayout: TopNav at md+, BottomNav at <md.
 * Each page picks its own max-width.
 */
export const StaffLayout = () => {
  const location = useLocation();
  const mainRef = useRef(null);

  useEffect(() => {
    if (mainRef.current) mainRef.current.scrollTop = 0;
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className="relative min-h-screen bg-napoli-espresso flex flex-col text-napoli-cream">
      <StaffTopNav />
      <main
        ref={mainRef}
        data-testid="staff-page"
        className="relative flex-1 pb-[88px] md:pb-12"
      >
        <div
          key={location.pathname}
          className="animate-in fade-in duration-200"
          data-testid="staff-page-content"
        >
          <Outlet />
        </div>
      </main>
      <StaffBottomNav />
    </div>
  );
};

export default StaffLayout;
